export enum SearchType {
    Point = 0,
    Area = 1,
    Phone = 2,
    Account = 3
}
